import { render, staticRenderFns } from "./ReviewsCategoryDetails.vue?vue&type=template&id=2b19d47a&scoped=true&"
import script from "./ReviewsCategoryDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoryDetails.vue?vue&type=style&index=0&id=2b19d47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19d47a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
